import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import ProductsSection from '../components/ProductsSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import ProjectsSection from '../components/ProjectsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ProcessSection from '../components/ProcessSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import PromotionBanner from '../components/PromotionBanner';

const HomePage: React.FC = () => {
  useEffect(() => {
    // Google Analytics
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-SDHCNDS5MG';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-SDHCNDS5MG');
    `;
    document.head.appendChild(script2);

    // Set document title and meta tags
    document.title = 'Evie Outdoors - Premium Outdoor Living Solutions | Ontario';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Transform your outdoor space with luxury pergolas and motorized awnings. Professional installation across Ontario with industry-leading warranties. Starting from $900.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'pergolas Ontario, outdoor awnings, outdoor living, motorized pergolas, retractable awnings, Canadian outdoor structures');
    }

    // Cleanup function
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return (
    <div className="bg-white">
      <PromotionBanner />
      <Navigation />
      <HeroSection />
      <ProductsSection />
      <WhyChooseUsSection />
      <ProjectsSection />
      <TestimonialsSection />
      <ProcessSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
